"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRaisinComDomain = exports.isUnitedKingdomDomain = exports.isLocalhost = exports.getEnvironmentFromAwsVars = exports.isLocalEnv = exports.getEnvironment = exports.checkHost = exports.getNamespaceName = exports.isCOM = exports.getRegionFromHost = exports.isCSR = void 0;

var domain_1 = require("../constants/domain");

var i18n_1 = require("../constants/i18n");

var types_1 = require("../types");

var isCSR = function isCSR() {
  return typeof window !== 'undefined';
};

exports.isCSR = isCSR;

var getRegionFromHost = function getRegionFromHost() {
  var _a, _b;

  return (0, exports.isCSR)() && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.endsWith('.co.uk')) ? i18n_1.COUNTRIES_ISO_3.GBR : i18n_1.COUNTRIES_ISO_3.DEU;
};

exports.getRegionFromHost = getRegionFromHost;

var isCOM = function isCOM() {
  return (0, exports.isCSR)() && window.location.hostname.endsWith('.com');
};

exports.isCOM = isCOM;

var getNamespaceName = function getNamespaceName() {
  if ((0, exports.isCSR)()) {
    var name_1 = /bk-(deu|gbr)-(.*)\.raisin-dev\.network/.exec(window.location.host);
    return name_1 ? name_1[2] : types_1.EnvironmentTypes.DEVELOPMENT;
  }

  return types_1.EnvironmentTypes.DEVELOPMENT;
};

exports.getNamespaceName = getNamespaceName;

var checkHost = function checkHost(host) {
  var _a;

  return (0, exports.isCSR)() && ((_a = window.location.host) === null || _a === void 0 ? void 0 : _a.includes(host));
};

exports.checkHost = checkHost;

var getEnvironment = function getEnvironment() {
  if ((0, exports.checkHost)(types_1.EnvironmentTypes.STAGING)) return types_1.EnvironmentTypes.STAGING;
  if ((0, exports.checkHost)(types_1.EnvironmentTypes.ONBOARDING)) return types_1.EnvironmentTypes.ONBOARDING;
  if ((0, exports.checkHost)(types_1.EnvironmentTypes.PRODUCTION)) return types_1.EnvironmentTypes.PRODUCTION;
  if ((0, exports.checkHost)(types_1.EnvironmentTypes.AMPLIFY_APP)) return types_1.EnvironmentTypes.DEVELOPMENT;
  if ((0, exports.checkHost)('raisin-dev.network')) return (0, exports.getNamespaceName)();
  if ((0, exports.checkHost)('localhost')) return types_1.EnvironmentTypes.LOCAL;
  return types_1.EnvironmentTypes.PRODUCTION;
};

exports.getEnvironment = getEnvironment;
exports.isLocalEnv = domain_1.LOCAL_ENVS.some(function (env) {
  return (0, exports.isCSR)() && env.test(window.location.host);
});

var getEnvironmentFromAwsVars = function getEnvironmentFromAwsVars(awsBranch, awsAppId) {
  if (types_1.EnvironmentTypes[String(awsBranch).toUpperCase()]) {
    return awsBranch;
  }

  return awsAppId ? types_1.EnvironmentTypes.DEVELOPMENT : types_1.EnvironmentTypes.LOCAL;
};

exports.getEnvironmentFromAwsVars = getEnvironmentFromAwsVars;

var isLocalhost = function isLocalhost() {
  return (0, exports.checkHost)('localhost');
};

exports.isLocalhost = isLocalhost;

var isUnitedKingdomDomain = function isUnitedKingdomDomain() {
  var _a, _b;

  return (0, exports.isCSR)() && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.endsWith('.co.uk'));
};

exports.isUnitedKingdomDomain = isUnitedKingdomDomain;

var isRaisinComDomain = function isRaisinComDomain() {
  var _a, _b;

  return (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.endsWith('raisin.com');
};

exports.isRaisinComDomain = isRaisinComDomain;